var React = require('react');

function Ses (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Amazon-Simple-Email-Service-SES"),React.createElement("path",{"d":"M37.5,12.5A25,25,0,0,0,17.21,52.09l1.62-1.17A23,23,0,1,1,60.5,37.5a22.81,22.81,0,0,1-4.33,13.42l1.62,1.17A25,25,0,0,0,37.5,12.5Z","key":1}),React.createElement("path",{"d":"M50.5,52.12V48.5a1,1,0,0,0-1-1h-11v-6h11a1,1,0,0,0,1-1v-15a1,1,0,0,0-1-1h-24a1,1,0,0,0-1,1v15a1,1,0,0,0,1,1h11v6h-11a1,1,0,0,0-1,1v3.62a4.5,4.5,0,1,0,2,0V49.5h10v4.12a4.5,4.5,0,1,0,2,0V49.5h10v2.62a4.5,4.5,0,1,0,2,0ZM41.77,33.05,48.5,27.6V38.42Zm-4.27.88L28.32,26.5H46.68ZM33.19,33l-6.69,5.4V27.6Zm1.59,1.29L36.87,36a1,1,0,0,0,1.26,0l2-1.66,6.46,5.16H28.33ZM28,56.5A2.5,2.5,0,1,1,25.5,54,2.5,2.5,0,0,1,28,56.5ZM40,58a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,40,58Zm9.5,1A2.5,2.5,0,1,1,52,56.5,2.5,2.5,0,0,1,49.5,59Z","key":2})]);
}

Ses.defaultProps = {"viewBox":"0 0 75 75"};

module.exports = Ses;

Ses.default = Ses;
